/**
 * Build the project programme (editable stage durations).
 * Default: prep 6 + auth 6 + construction offset 2 + construction 18 + delivery buffer 2 = 34 months.
 */

import { hydrateAssumptions } from './defaults.js';

export function buildProgramme(rawAssumptions = {}) {
  const a = hydrateAssumptions(rawAssumptions);
  const prepEnd = a.prepMonths;
  const authorizationEnd = prepEnd + a.authMonths;
  const permitMonth = Math.max(1, authorizationEnd);
  // Land acquisition is independent of permit. Default: end of preparation.
  const defaultAcquisition = Math.max(1, prepEnd || 1);
  // Construction payments start after an explicit post-authorization offset
  // (default 2). Bank facility activation still keys off permitMonth.
  const constructionStart = permitMonth + (a.constructionStartOffsetFromAuth || 0);
  const constructionEnd = constructionStart + a.constructionMonths;
  const deliveryMonth = constructionEnd + a.deliveryBufferMonths;
  const totalMonths = Math.max(1, deliveryMonth);
  // Land month is already hydrated into [1, totalMonths]; keep that contract here.
  const acquisitionMonth = a.landAcquisitionMonth != null
    ? Math.max(1, Math.min(a.landAcquisitionMonth, totalMonths))
    : defaultAcquisition;

  return {
    prepEnd,
    authorizationEnd,
    permitMonth,
    acquisitionMonth,
    constructionStart,
    constructionEnd,
    deliveryMonth,
    totalMonths,
    prepMonths: a.prepMonths,
    authMonths: a.authMonths,
    constructionMonths: a.constructionMonths,
    deliveryBufferMonths: a.deliveryBufferMonths,
  };
}

/** Stage label for a calendar month (1-indexed). */
export function stageAtMonth(month, programme) {
  const m = Number(month) || 0;
  if (m <= 0) return 'pre-start';
  if (m <= programme.prepEnd) return 'preparation';
  if (m <= programme.authorizationEnd) return 'authorization';
  if (m <= programme.constructionEnd) return 'construction';
  if (m <= programme.deliveryMonth) return 'delivery';
  return 'complete';
}
